/** Numbered pet theme demos under /demos/pets (alphabetical source order). */
export const PET_DEMO_IDS = [1, 2, 3, 4, 5] as const

export type PetDemoId = (typeof PET_DEMO_IDS)[number]

export function isPetDemoId(value: string): value is `${PetDemoId}` {
  return PET_DEMO_IDS.includes(Number(value) as PetDemoId)
}

export function parsePetDemoId(value: string): PetDemoId | null {
  if (!isPetDemoId(value)) return null
  return Number(value) as PetDemoId
}

export function petDemoImagePath(id: PetDemoId) {
  return `/demos/pets/${id}.png`
}

export function petDemoThumbPath(id: PetDemoId) {
  return `/demos/pets/thumbs/${id}.jpg`
}

export function petDemoPagePath(id: PetDemoId) {
  return `/demos/pets/${id}`
}
